// @flow
import type { Subject } from 'src/Support/Contact/types';

type Params = {
  category?: string,
  subject?: Subject,
  topic?: string,
};

const helpdesk = 'https://helpdesk.gandi.net/hc';

// Use https://docs.google.com/spreadsheets/d/1WwoRiT-zC8uCPszs4Ozj7s4yuyKiGLbtCeku7FXCKGQ/edit?usp=sharing
// for generayed object more easily
const requestType = 'tf_10384615292956';
const technical = 'tf_10387648128156';
const admin = 'tf_9006704747036';

const queries = {
  'domain/dn-zone': {
    [requestType]: 'technical',
    [technical]: 'dns_records',
  },
  'domain/dn-cancel': {
    [requestType]: 'admin',
    [admin]: 'domain_cancel',
  },
  'domain/dn-dnssec': {
    [requestType]: 'technical',
    [technical]: 'dnssec',
  },
  'domain/dn-handle': {
    [requestType]: 'admin',
    [admin]: 'logging_issues',
  },
  'domain/dn-dns': {
    [requestType]: 'technical',
    [technical]: 'nameserver',
  },
  'domain/dn-status': {
    [requestType]: 'admin',
    [admin]: 'domain_order_status',
  },
  'domain/dn-owner': {
    [requestType]: 'admin',
    [admin]: 'domain_owner',
  },
  'domain/dn-cost': { [requestType]: 'quotation' },
  'domain/dn-buy': {
    [requestType]: 'admin',
    [admin]: 'domain_purchase',
  },
  'domain/dn-renw': {
    [requestType]: 'technical',
    [technical]: 'domain_renew',
  },
  'domain/dn-trans': {
    [requestType]: 'admin',
    [admin]: 'domain_transfer',
  },
  'domain/dn-redir': {
    [requestType]: 'technical',
    [technical]: 'web_fwd',
  },
  'domain/dn-whois': {
    [requestType]: 'admin',
    [admin]: 'account_name_change',
  },
  'domain/dn-feedback': {
    [requestType]: 'admin',
    [admin]: 'other_cat',
  },
  'domain/dn-other': {
    [requestType]: 'admin',
    [admin]: 'other_cat',
  },
  'gandimail/mail-add': {
    [requestType]: 'technical',
    [technical]: 'mail_config',
  },
  'gandimail/mail-cancel': {
    [requestType]: 'admin',
    [admin]: 'mail_cancel',
  },
  'gandimail/mail-mx': {
    [requestType]: 'technical',
    [technical]: 'mail_config',
  },
  'gandimail/mail-pack': {
    [requestType]: 'admin',
    [admin]: 'mail_offer',
  },
  'gandimail/mail-newoffer': {
    [requestType]: 'admin',
    [admin]: 'mail_offer',
  },
  'gandimail/mail-mdp': {
    [requestType]: 'technical',
    [technical]: 'mail_config',
  },
  'gandimail/mail-receiving-problems': {
    [requestType]: 'technical',
    [technical]: 'mail_receiving',
  },
  'gandimail/mail-sending-problems': {
    [requestType]: 'technical',
    [technical]: 'mail_sending',
  },
  'gandimail/mail-cost': {
    [requestType]: 'admin',
    [admin]: 'mail_offer',
  },
  'gandimail/mail-phishing': {
    [requestType]: 'technical',
    [technical]: 'phishing',
  },
  'gandimail/mail-feedback': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'gandimail/mail-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'shs/shs-transfer-file': {
    [requestType]: 'technical',
    [technical]: 'file_transfer',
  },
  'shs/shs-db': {
    [requestType]: 'technical',
    [technical]: 'database',
  },
  'shs/shs-renew': {
    [requestType]: 'admin',
    [admin]: 'hosting_renewal',
  },
  'shs/shs-attach-domain': {
    [requestType]: 'admin',
    [admin]: 'hosting_attach_domain',
  },
  'shs/shs-quota': { [requestType]: 'technical' },
  'shs/shs-price': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'shs/shs-mode-payment': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'shs/shs-cancel': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'shs/shs-change-owner': {
    [requestType]: 'admin',
    [admin]: 'hosting_change_owner',
  },
  'shs/shs-feedback': { [requestType]: 'admin', [admin]: 'other' },
  'shs/shs-other': { [requestType]: 'admin', [admin]: 'other' },
  'vps/vps-creation': {
    [requestType]: 'technical',
    [technical]: 'cloud_billing',
  },
  'vps/vps-access': {
    [requestType]: 'admin',
    [admin]: 'cloud_access',
  },
  'vps/vps-renw': {
    [requestType]: 'admin',
    [admin]: 'hosting_renewal',
  },
  'vps/vps-bloc': {
    [requestType]: 'technical',
    [technical]: 'blocked_server',
  },
  'vps/vps-bill': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'vps/vps-cancel': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'vps/vps-feedback': { [requestType]: 'admin', [admin]: 'other' },
  'vps/vps-other': { [requestType]: 'admin', [admin]: 'other' },
  'hosting/host-renw': {
    [requestType]: 'admin',
    [admin]: 'hosting_renewal',
  },
  'hosting/host-mdp': {
    [requestType]: 'admin',
    [admin]: 'cloud_access',
  },
  'hosting/host-trans': {
    [requestType]: 'admin',
    [admin]: 'hosting_change_owner',
  },
  'hosting/host-bloc': {
    [requestType]: 'technical',
    [technical]: 'blocked_server',
  },
  'hosting/host-monan': { [requestType]: 'technical' },
  'hosting/host-cost': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'hosting/host-cancel': {
    [requestType]: 'admin',
    [admin]: 'cloud_billing',
  },
  'hosting/host-feedback': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'hosting/host-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'certificate/ssl-buy': {
    [requestType]: 'admin',
    [admin]: 'ssl_purchase',
  },
  'certificate/ssl-renew': {
    [requestType]: 'admin',
    [admin]: 'ssl_renewal',
  },
  'certificate/ssl-del': {
    [requestType]: 'technical',
    [technical]: 'ssl_revoc',
  },
  'certificate/ssl-valid': {
    [requestType]: 'admin',
    [admin]: 'ssl_activation',
  },
  'certificate/ssl-feedback': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'certificate/ssl-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'marketplace/marketplace-sitebuilder': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'marketplace/marketplace-feedback': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'marketplace/marketplace-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'api/api-start': { [requestType]: 'technical' },
  'api/api-errors': { [requestType]: 'technical' },
  'api/api-feedback': { [requestType]: 'admin' },
  'billing/bill-method': {
    [requestType]: 'admin',
    [admin]: 'means_paiement',
  },
  'billing/bill-prepaid': {
    [requestType]: 'admin',
    [admin]: 'means_paiement',
  },
  'billing/bill-check': {
    [requestType]: 'admin',
    [admin]: 'means_paiement',
  },
  'billing/bill-paypal': {
    [requestType]: 'admin',
    [admin]: 'means_paiement',
  },
  'billing/bill-wire': {
    [requestType]: 'admin',
    [admin]: 'means_paiement',
  },
  'billing/bill-cancel': { [requestType]: 'admin' },
  'billing/bill-error': { [requestType]: 'admin' },
  'billing/bill-feedback': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'billing/bill-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  'account/account-merge': {
    [requestType]: 'admin',
    [admin]: 'merging_accounts',
  },
  'account/account-name': {
    [requestType]: 'admin',
    [admin]: 'account_name_change',
  },
  'account/account-login': {
    [requestType]: 'admin',
    [admin]: 'logging_issues',
  },
  'account/account-email': {
    [requestType]: 'admin',
    [admin]: 'email_change',
  },
  'account/account-password': {
    [requestType]: 'admin',
    [admin]: 'logging_issues',
  },
  'account/account-totp': {
    [requestType]: 'admin',
    [admin]: '2authentication',
  },
  'account/account-delete': {
    [requestType]: 'admin',
    [admin]: 'delete_account',
  },
  'account/account-feedback': {
    [requestType]: 'admin',
    [admin]: 'other_cat',
  },
  'account/account-other': {
    [requestType]: 'admin',
    [admin]: 'other_cat',
  },
  'migration/migra-account': {
    [requestType]: 'admin',
    [admin]: 'logging_issues',
  },
  'migration/migra-domain': {
    [requestType]: 'admin',
    [admin]: 'logging_issues',
  },
  'migration/migra-other': {
    [requestType]: 'admin',
    [admin]: 'other',
  },
  feedback: { [requestType]: 'admin', [admin]: 'other' },
};

function urlSignin(urlWithLocale: string) {
  return `/signin?return_to=${encodeURIComponent(urlWithLocale)}`;
}

function addQueryString(params: Params) {
  const key = Object.values(params).filter(Boolean).join('/');

  return key in queries
    ? `?${new URLSearchParams(queries[key]).toString()}`
    : '';
}

export function urlRedirectToHelpdesk({
  lang,
  params,
  query,
  isAuthenticated,
}: {
  lang: string,
  params?: Params,
  query: { +navigation?: ?string, +livechat?: ?string, +[string]: ?string },
  isAuthenticated: boolean,
}): string {
  let url = helpdesk;

  switch (lang) {
    case 'zh-hans':
    case 'zh-hant':
      url += '/zh-tw';
      break;
    case 'en':
      url += '/en-us';
      break;
    default:
      url += `/${lang}`;
      break;
  }

  const baseUrl = url;

  if (params && params.subject) {
    url += `/requests/new${addQueryString(params)}`;
  }

  if (query && 'livechat' in query) {
    url += url.includes('?') ? '&livechat' : '?livechat';
  }

  if (isAuthenticated) {
    return `${baseUrl}${urlSignin(url)}`;
  }

  return url;
}

export function shouldRedirect(params?: Params): boolean {
  const isStandalone = params && params.subject && params.subject.match(/-/);
  return !params || !isStandalone;
}
